/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import searchIcon from "dc-icons/global/s_search_18.svg";
import CustomIcon from "dc-preview-utils/src/components/CustomIcon";
import { enableSearchUI } from "selectors/searchSelectors";
import { getViewMode } from "selectors/viewModeSelectors";
import { isMac } from "dc-preview-utils/src/Utils/DeviceUtils";

export const searchClickHandler = stores => {
  if (enableSearchUI(stores)) {
    stores.searchStore.setShowSearchInputUI(true, getViewMode(stores));
  }
};

export const cssSetterHandler = (stores, customCss) => {
  if (customCss) {
    stores.searchStore.setCustomCss(customCss);
  }
  stores.searchStore.setUseFullWidthOnTablet(customCss.useFullWidthOnTablet);
};

export const updateSearchStyle = (stores, styleInfo) => {
  stores.searchStore.setSearchInputClassName(styleInfo.searchInputClassName);
  stores.searchStore.setSearchWidgetClassName(styleInfo.searchWidgetClassName);
  stores.searchStore.setSearchInputStyle(styleInfo.searchInputStyle);
  stores.searchStore.setSearchWidgetStyle(styleInfo.searchWidgetStyle);
};

class SearchIcon extends React.Component {
  componentDidMount() {
    this.props.onMount && this.props.onMount();
  }

  render() {
    return <CustomIcon url={searchIcon} />;
  }
}

export const getFindAction = ({
  intl,
  searchClickHandler,
  cssSetterHandler,
  updateSearchStyle,
  isPDF,
  shouldShowSearchInHud,
  isSearchInputVisible,
  shouldUnblockUIFeatures,
  useModernViewer
}) => {
  if (!isPDF || shouldShowSearchInHud || (!useModernViewer && isSearchInputVisible) || !shouldUnblockUIFeatures) {
    return null;
  }

  return {
    id: "documentSearch",
    label: intl.formatMessage(
      { id: "tooltip.searchInDocument" },
      { shortcut: isMac() ? "Command + F" : "Control + F" }
    ),
    onClick: searchClickHandler,
    cssSetter: cssSetterHandler,
    Icon: <SearchIcon onMount={updateSearchStyle} />
  };
};
